import { Link } from "react-router-dom";
import { Camera } from "lucide-react";

export function PhotoChallenge({ challenge }) {
  if (!challenge) return null;
  const n = challenge.found.length;
  const pct = Math.min(100, Math.round((n / challenge.target) * 100));
  return (
    <section className="bg-white rounded-2xl border-2 border-slate-200 p-5 space-y-3 rise rise-1" data-testid="team-photo-challenge">
      <div className="flex items-center justify-between">
        <span className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-slate-500">
          <Camera className="w-4 h-4 text-orange-500" /> Défi photo de la semaine
        </span>
        <Link to="/photo-outil" data-testid="team-photo-challenge-link" className="text-xs font-bold text-orange-600 hover:underline">Photographier</Link>
      </div>
      <p className="font-display text-2xl font-bold uppercase leading-tight">{challenge.target} outils différents</p>
      <div className="h-6 rounded-full bg-slate-100 border border-slate-200 overflow-hidden relative">
        <div className={`h-full transition-[width] duration-700 ${challenge.done ? "bg-emerald-500" : "bg-sky-500"}`} style={{ width: `${pct}%` }} data-testid="team-photo-bar" />
        <span className="absolute inset-0 grid place-items-center text-xs font-bold text-slate-900" data-testid="team-photo-count">{n} / {challenge.target}</span>
      </div>
      {challenge.done && <p className="text-sm font-bold text-emerald-700" data-testid="team-photo-won">Défi photo réussi, trophée gagné !</p>}
      {n > 0 && (
        <div className="flex flex-wrap gap-2" data-testid="team-photo-found">
          {challenge.found.map((w) => (
            <span key={w} className="text-xs font-bold rounded-full px-3 py-1 bg-sky-100 text-sky-900">{w}</span>
          ))}
        </div>
      )}
    </section>
  );
}
